import { Chip as MuiChip } from '@mui/material';
import React, { ReactElement } from 'react';

export interface ChipProps {
  label: string;
  height?: number;
  style?: React.CSSProperties;
}

export const Chip = ({
  label,
  height = 27,
  style,
}: ChipProps): ReactElement => {
  return (
    <MuiChip
      label={label}
      sx={{
        marginLeft: 5,
        background: '#fff',
        border: '1px solid #d9d9d9',
        color: theme => theme.palette.neutral.darkest,
        fontWeight: 500,
        fontSize: '0.75em',
        height: height,
        borderRadius: height / 2,
        '& .MuiChip-label': {
          paddingLeft: 15,
          paddingRight: 15,
        },
      }}
      style={style}
    />
  );
};
